import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { WarehouseTable } from "./WarehouseTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./warehouseSlice";
import { useParams } from "react-router-dom";
import { getValueOptions } from "../../utility";
import Select from "react-select";

export const WarehousePage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [retNumber, setRetNumber] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [typeReturn, setTypeReturn] = useState("");

  const { id } = useParams();

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      dispatch(
        fetchAll({
          stepCode: "CW",
          retNumber: id,
          group: true,
          pageNo: pageNo,
          pageSize: pageSize,
        })
      );
    }
  }, [id]);

  const handleSearch = () => {
    const params = {
      stepCode: "CW",
      startDate: startDate,
      endDate: endDate,
      invoiceNo: invoiceNo,
      retNumber: retNumber.replace(/\s/g, ""),
      customerName: customerName,
      customerCode: customerCode,
      typeReturn: typeReturn,
      group: true,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      stepCode: "CW",
      startDate: startDate,
      endDate: endDate,
      invoiceNo: invoiceNo,
      retNumber: retNumber.replace(/\s/g, ""),
      customerName: customerName,
      customerCode: customerCode,
      typeReturn: typeReturn,
      group: true,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const typeReturnOptions = [
    { value: "", label: "All" },
    { value: "MTKA", label: "With RTV" },
    { value: "NON MTKA", label: "Without RTV" },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Chief Warehouse"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form as={Row}>
          {/* Left Row */}
          <Col sm={7}>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Upload PFRE Date</b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="date"
                  placeholder="Start Date"
                  sm={6}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={startDate}
                />
              </Col>
              <p>To</p>
              <Col sm={4}>
                <Form.Control
                  type="date"
                  placeholder="End Date"
                  sm={6}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={endDate}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>APL Return Number </b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  placeholder="APL Return Number "
                  onChange={(e) => {
                    setRetNumber(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={retNumber}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Type Return</b>
              </Form.Label>
              <Col sm={5}>
                <Select
                  options={typeReturnOptions}
                  value={getValueOptions(typeReturn, typeReturnOptions)}
                  // placeholder="Select ..."
                  onChange={(e) => {
                    setTypeReturn(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Right Row */}
          <Col sm={5}>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Invoice Ref Number</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Invoice Ref Number"
                  onChange={(e) => {
                    setInvoiceNo(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={invoiceNo}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Customer Name</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Customer Name"
                  onChange={(e) => {
                    setCustomerName(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={customerName}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Customer Code</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Customer Code"
                  onChange={(e) => {
                    setCustomerCode(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  value={customerCode}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Button */}
          <Form.Group as={Row} className="">
            <Col sm={6}>
              <Button className="btn btn-primary ml-1" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data && data.length > 0 && (
          <WarehouseTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
